import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';

import { Menu, Divider } from 'react-native-paper';
import { useTheme } from '../../theme';
import { Icon } from '../icon';

const DotMenu = ({
	menuOptions,
	forceDots,
}) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const { theme } = useTheme();
	const menuBackgroundColor = theme.mainBg18 || theme.mainBg1;

	return (
		<>
			{
				(menuOptions.length > 1 || forceDots) && (
					<Menu
						style={{
							marginTop: 30,
						}}
						contentStyle={{
							backgroundColor: menuBackgroundColor,
							paddingVertical: 0,
						}}
						visible={menuOpen}
						onDismiss={() => setMenuOpen(false)}
						anchor={(
							<TouchableOpacity
								onPress={() => setMenuOpen(true)}
								style={{
									paddingTop: 3,
									paddingLeft: 10,
									paddingRight: 16,
								}}
							>
								<Icon
									name="moreVertical"
									color={theme.text1}
								/>
							</TouchableOpacity>
						)}
					>
						{
							menuOptions.map((menuOption, index) => {
								if (menuOption.divider) {
									return (
										<Divider
											key={index}
											style={{
												backgroundColor: theme.border1 || theme.mainBg3,
											}}
										/>
									);
								}

								return (
									<Menu.Item
										titleStyle={{
											fontSize: 16,
											color: theme.text1,
										}}
										key={index}
										onPress={() => {
											setMenuOpen(false);
											return menuOption.onPress();
										}}
										title={menuOption.title}
									/>
								)
							})
						}

					</Menu>
				)
			}
		</>
	);
};

export default DotMenu;
